import React, { useState, Fragment, useRef, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { fontSize } from "../../helpers/fontSize";
import { Colors } from "../../helpers/Colors";
import { MdOutlineMeetingRoom } from "react-icons/md";
import { Cabins } from "../../helpers/Cabins";
import { CalendarComponent } from "@syncfusion/ej2-react-calendars";
import CabinComponent from "./section/CabinComponent";
import DateComponent from "./section/DateComponent";
import Slider from "react-slick";
import toast, { Toaster } from "react-hot-toast";
import { addMinutes, format, startOfToday } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import {
  remove_reservation_details,
  reservation_cabinName,
  reservation_details,
} from "../../redux/Features/Reservation/ReservationSlice";
import axios from "axios";
import { Durations } from "../../helpers/Durations";

const useStyles = makeStyles({
  Reservation: {
    // zIndex: 0,
    backgroundColor: Colors.primaryExtraLight2,
    // padding: "0 0 10px 0",
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  Heading: {
    fontSize: fontSize.ProductName,
    padding: "10px 20px",
  },
  Content: {
    width: "auto",
    height: "100%",
    // zIndex: 0,
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // height: "fit-content",
    // backgroundColor: Colors.primaryLight,
    borderRadius: "10px",
    padding: "5px 0px 0 0",
    // height: "fit-content",
    // width: "100%",
    // padding: "10px 40px",
    "& .Overall_Cabin_Con": {
      zIndex: 2,
      padding: "10px 0 10px 0",
      // display: "flex",
      // alignItems: "center",
      // justifyContent: "flex-start",
      // padding: "0px 40px",
      // backgroundColor: Colors.error,
      // width: "100%",
      // maxWidth: "100vw",
      // flexGrow: "1",
    },
    "& .Overall_Date_Con": {
      // backgroundColor: Colors.success,
    },
    "& .Overall_Time_Con": {
      // backgroundColor: Colors.grey,
    },
  },
  cabin1: {
    color: Colors.tom,
  },
  cabin2: {
    color: Colors.spike,
  },
  cabin3: {
    color: Colors.tyke,
  },
  cabin4: {
    color: Colors.jerry,
  },
  Label: {
    width: "fit-content",
  },
});

const Reservation = ({
  token,
  user,
  isSuperAdmin,
  setIsSuperAdmin,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reservation = useSelector((state) => state.reservation.details);

  const [cabinName, setCabinName] = useState("");
  // console.log(cabinName);
  const [cabinId, setCabinId] = useState("");
  // console.log(cabinId);
  const [slider, setSlider] = useState("");
  const [reservationDetails, setReservationDetails] = useState(reservation);

  const onChangeHandler = (e) => {
    setCabinName(e.target.value);
    setCabinId(e.target.name);
  };

  const [employeeDetails, setEmployeeDetails] = useState([]); // setting the state which will come from DB

  // ********************************************
  // At DateComponent.js

  const today = startOfToday();
  const [selectedDay, setSelectedDay] = useState(today);

  const [startTime, setStartTime] = useState(new Date()); // startTime
  const [endTime, setEndTime] = useState(new Date()); // endTime

  const add15mins = addMinutes(startTime, 15); // Adds 15mins to the startTime
  const add30mins = addMinutes(startTime, 30); // Adds 30mins to the startTime
  const add1hr = addMinutes(startTime, 60); // Adds 1hr to the startTime

  const [addTimetoStart, setAddTimetoStart] = useState("");
  // For Automatically adding 15mins to the startTime
  const [startTimePlus15mins, setStartTimePlus15mins] = useState(new Date());
  // For Automatically adding 30mins to the startTime
  const [startTimePlus30mins, setStartTimePlus30mins] = useState(new Date());
  // For Automatically adding 1hr to the startTime
  const [startTimePlus1hr, setStartTimePlus1hr] = useState(new Date());

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    draggable: false,
    accessibility: false,
  };

  const sliderRef = useRef();

  const slideToPrevious = () => {
    sliderRef.current.slickPrev();
  };
  const slideToCabinPrevious = () => {
    sliderRef.current.slickPrev();
    dispatch(reservation_cabinName([]));
  };
  const slideToDatePrevious = () => {
    sliderRef.current.slickPrev();
    dispatch(remove_reservation_details(null));
  };

  const selectCabinPlease = () => {
    toast.error("Please, Select a Cabin!");
  };
  const selectDatePlease = () => {
    toast.error("Please, Select a Date!");
  };
  const selectTimePlease = () => {
    toast.error("Please, Select a Time!");
  };
  const enterDetailsPlease = () => {
    toast.error("Please, Enter the Details!");
  };

  useEffect(() => {
    if (user !== null) {
      if (
        user.email === "akbar.s@dyooti.com" ||
        user.email === "hr@dyooti.com"
      ) {
        setIsSuperAdmin(true);
        toast.success(
          <div className="flex items-center justify-center">
            Welcome
            <span
              className="mx-1 underline font-bold bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2 
          via-logo3 via-logo4  via-logo7 to-logo8"
            >
              {/* {user.name} */}
              Super Admin !
            </span>
            <div className="animate-skew w-fit transform transition-all ease-in-out duration-300">
              <span>❤️</span>
            </div>
          </div>,
          {
            duration: 2000,
          }
        );
      } else {
        setIsSuperAdmin(false);
        toast.success(
          <div className="flex items-center justify-center">
            Welcome{" "}
            <span
              className="underline font-bold bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2 
          via-logo3 via-logo4  via-logo7 to-logo8"
            >
              {user.name}
            </span>{" "}
            <div className="animate-jiggle mx-1 w-fit transform transition-all ease-in-out duration-300">
              <span>🤙</span>
            </div>
            !
          </div>,
          {
            duration: 2000,
          }
        );
      }
    }
  }, [user]);

  console.log("endTime - " + endTime);

  // getEmployee (GET)
  useEffect(() => {
    axios.get("/api/get/getEmployee").then((res) => {
      if (res) {
        // console.log("Got Employee detials from DB via axios");
        setEmployeeDetails(res.data);
      } else
        return console.log(
          "Error while getting Employee details from DB via axios"
        );
    });
  }, []);

  return (
    <main
      // className={`${classes.Reservation} flex items-center justify-center`}
      className={`${classes.Reservation}`}
      style={{ height: "calc(100vh - 58px)" }}
    >
      {/* <Toaster /> */}
      <section className={`${classes.Content}`}>
        {/*  max-w-md px-4 mx-auto sm:px-7 md:max-w-5xl md:px-6 */}
        <div className="Overall_Cabin_Con">
          <CabinComponent
            cabinId={cabinId}
            cabinName={cabinName}
            setCabinName={setCabinName}
            onChangeHandler={onChangeHandler}
            // slideNextToDate={slideNextToDate}
            selectCabinPlease={selectCabinPlease}
            triggerUseEffect={triggerUseEffect}
            setUseEffect={setUseEffect}
          />
        </div>
        <div className="Overall_Date_Con">
          {/* {JSON.stringify(selectedDay)} */}
          <DateComponent
            user={user}
            sliderRef={sliderRef}
            cabinId={cabinId}
            cabinName={cabinName}
            today={today}
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            startTime={startTime}
            setStartTime={setStartTime}
            add15mins={add15mins}
            add30mins={add30mins}
            add1hr={add1hr}
            endTime={endTime}
            setEndTime={setEndTime}
            addTimetoStart={addTimetoStart}
            setAddTimetoStart={setAddTimetoStart}
            startTimePlus15mins={startTimePlus15mins}
            setStartTimePlus15mins={setStartTimePlus15mins}
            startTimePlus30mins={startTimePlus30mins}
            setStartTimePlus30mins={setStartTimePlus30mins}
            startTimePlus1hr={startTimePlus1hr}
            setStartTimePlus1hr={setStartTimePlus1hr}
            slideToPrevious={slideToPrevious}
            // slideNextToDetails={slideNextToDetails}
            selectCabinPlease={selectCabinPlease}
            selectDatePlease={selectDatePlease}
            triggerUseEffect={triggerUseEffect}
            setUseEffect={setUseEffect}
          />
        </div>
        <div className="Overall_Time_Con"></div>
      </section>
    </main>
  );
};

export default Reservation;
